/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type PCCDashboardPillFilter = typeof PCCDashboardPillFilter[keyof typeof PCCDashboardPillFilter];


export const PCCDashboardPillFilter = {
  Enrolled: 'Enrolled',
  NeedsAttention: 'NeedsAttention',
  EligibleNotEnrolled: 'EligibleNotEnrolled',
  WaitingForConsent: 'WaitingForConsent',
} as const;
